import { View } from 'foundations-components/components/View';
import FeatureCard from 'marketplace-ui-apps-core/details/components/FeatureCard';
import { getMissingCompatibilityRequirements } from 'marketplace-ui-apps-core/installability/utils/featureCompatibilities';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
// @ts-expect-error untyped dependency
import { getIsCustomer } from '../../../selectors/auth';
import { FeatureCardCompatibility } from './FeatureCardCompatibility';
import { jsx as _jsx } from "react/jsx-runtime";
export function FeatureCards({
  features,
  installability,
  isPreview,
  onTrackInteraction,
  openFeatureCompatibilityModal
}) {
  const isCustomer = useSelector(getIsCustomer);
  const missingCompatibilityRequirements = getMissingCompatibilityRequirements(features, installability, isCustomer);
  return /*#__PURE__*/_jsx(Fragment, {
    children: features.map((feature, index) => {
      const missingCompatibilityRequirement = missingCompatibilityRequirements && missingCompatibilityRequirements[index];
      return /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(FeatureCard, {
          feature: feature,
          onImageClick: () => onTrackInteraction('click integration feature screenshot', {
            section: 'overview'
          }),
          children: installability && !isPreview ? /*#__PURE__*/_jsx(FeatureCardCompatibility, {
            onTrackInteraction: onTrackInteraction,
            missingCompatibilityRequirement: missingCompatibilityRequirement,
            openFeatureCompatibilityModal: openFeatureCompatibilityModal
          }) : null
        })
      }, feature.id);
    })
  });
}